import { gql } from "@apollo/client";

export const QUERY_RESS_PIT_BOOST_ENERGY_ADJUSTMENTS = gql`
  query getRessPitBoostEnergyAdjustments(
    $strategyImportId: String!
    $strategyImportDt: Float
  ) {
    getRessPitBoostEnergyAdjustments(
      strategyImportId: $strategyImportId
      strategyImportDt: $strategyImportDt
    ) {
      strategyImportId
      strategyImportDt
      pitBoostEnergyAdjustmentskWh
    }
  }
`;

const RESS_TRACE_FIELDS = `
  carColour
  ressTCellMax
  ressPBMSkW
`;

export const QUERY_RESS_TRACES = gql`
  query getRessTraces {
    getRaceData {
      ${RESS_TRACE_FIELDS}
    }
  }
`;

export const SUBSCRIBE_RESS_TRACE_UPDATE = gql`
  subscription newRessTraceUpdate {
    newLapTableUpdate {
      ${RESS_TRACE_FIELDS}
    }
  }
`;

const RESS_ENERGY_RUN_FIELDS = `
  completedAt
  dataFile
  targetEnergykWh
  selectedEnergykWh
`;

export const QUERY_LATEST_RESS_ENERGY_RUN = gql`
  query getLatestRessEnergyRun {
    getLatestRessEnergyRun {
      ${RESS_ENERGY_RUN_FIELDS}
    }
  }
`;

export const SUBSCRIBE_RESS_ENERGY_RUN = gql`
  subscription newRessEnergyRun {
    newRessEnergyRun {
      ${RESS_ENERGY_RUN_FIELDS}
    }
  }
`;

export const MUTATE_RUN_RESS_RACE_BUILDER = gql`
  mutation runRessRaceBuilder($inputs: RessModelInput!) {
    runRessModel(inputs: $inputs) {
      data {
        pitBoostLapIndex
        tCellMaxC
        packPowerkW
        pbmsKw
      }
      metadata {
        energySelection {
          targetEnergykWh
          selectedEnergykWh
        }
        dataset {
          requestedFile
          fileName
          source
          usage
        }
        ts {
          queryReceived
          dataLoaded
          raceBuilt
          fmuRan
          result
        }
      }
    }
  }
`;

export const QUERY_RESS_RACE_PROFILE = gql`
  query getRessRaceProfile(
    $totalRaceEnergykWh: Float!
    $numberOfLaps: Int!
    $dataFile: String!
  ) {
    getRessRaceProfile(
      totalRaceEnergykWh: $totalRaceEnergykWh
      numberOfLaps: $numberOfLaps
      dataFile: $dataFile
    ) {
      linearTargetkWh
      totalAttackTimeS
      attackLapDurationS
      attackLapCount
      laps {
        lapNumber
        energyTargetkWh
        attack
        tow
      }
    }
  }
`;
